import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageContext } from "../../context/MessageContext";
import { AuthContext } from "../../context/AuthProvider";
import { AppRouter } from "../../routers";
import Message from "../Message";
import ScrollToTop from "../ScrollToTop";
import useSegmentCapture from "../../hooks/useSegmentCapture";
import SignupPromoModal from "../SignupPromoModal";
import { Container } from "./styles";

const AppContainer = () => {
  const messageContext = useContext(MessageContext);
  const authContext = useContext(AuthContext);
  const userRole = authContext?.user?.role;
  const [showSignupPromo, setShowSignupPromo] = useState(false);

  // Show the post-signup promo modal once, after a successful signup.
  // SignUp page sets "show-signup-promo" in localStorage; we consume it here
  // when the auth state finishes resolving.
  useEffect(() => {
    if (!userRole || userRole === "loading" || userRole === "guest") return;
    if (localStorage.getItem("show-signup-promo") !== "1") return;
    localStorage.removeItem("show-signup-promo");
    // Don't pitch a subscription trial to users who have already made a
    // purchase (one-time orders and paid subscriptions both set `paidUser`).
    if (authContext?.user?.paidUser) return;
    setShowSignupPromo(true);
  }, [userRole]); // eslint-disable-line react-hooks/exhaustive-deps

  // Identify logged-in users to Tawk.to so admins can see who they're chatting with.
  useEffect(() => {
    if (userRole !== "private") return;
    const { fullName, email } = authContext?.user ?? {};
    if (!fullName && !email) return;
    const api = window.Tawk_API;
    if (!api?.setAttributes) return;
    api.setAttributes({ name: fullName, email }, err => {
      if (err) console.warn("Tawk.to setAttributes error:", err);
    });
  }, [userRole]); // eslint-disable-line react-hooks/exhaustive-deps

  // Capture & persist the marketing segment handed off from the landing
  // page (`?segment=N`). See hooks/useSegmentCapture.js.
  useSegmentCapture();

  // if ?creatorLicense is in the URL, set the creatorLicenseAvailable in localStorage
  const queryString = useLocation().search;
  const searchParams = new URLSearchParams(queryString);
  if (searchParams.has("creatorLicense")) {
    localStorage.setItem(
      "creatorLicenseAvailable",
      searchParams.get("creatorLicense").toLowerCase() === "true"
        ? "true"
        : "false"
    );
  }

  return (
    <Container>
      <ScrollToTop />
      {messageContext.show && (
        <div className="message-container">
          <Message {...messageContext} />
        </div>
      )}
      <AppRouter />
      <SignupPromoModal
        open={showSignupPromo}
        onClose={() => setShowSignupPromo(false)}
      />
    </Container>
  );
};

export default AppContainer;
